import React from 'react'
import { Route } from 'react-router'
import { isMeinBuero } from '@/utils/build-env'

const moduleSubscriptionList = React.lazy(() => import('@/modules/moduleSubscription/components/list/moduleSubscription-list'))
// DO-13587: orgaMAX opens the checkout directly instead of the shop page
const shopCheckoutRoute = React.lazy(() => import('@/modules/moduleSubscription/components/shop-checkout-route/shop-checkout-route'))

const shopRoutes = (
  <>
    <Route path='shop/:product?' Component={isMeinBuero() ? moduleSubscriptionList : shopCheckoutRoute} />
  </>
)

export default shopRoutes
